import http from '@/http'

/**
 * Catálogo de BRINDES: todas as tags do evento classificadas como `gift`. É o
 * que o modo Brinde usa pra montar o checklist da ficha (ter a tag = elegível).
 * Não é filtrado por escopo do operador — a permissão de autorizar/entregar
 * cada brinde é resolvida por tag no front (via as tags do escopo).
 */
export async function fetchGiftCatalog () {
  const response = await http.get('/admin/check-in/gift-tags', { params: { limit: 1000 } })
  if (response.status !== 200) {
    const exc: any = { CODID: 'GFTCAT01', response }
    exc['error'] = new Error(exc.CODID)
    throw exc
  }

  const tags = response.data.data

  return tags.map((tag: any) => ({
    id: tag.id,
    name: tag.name,
    eligibleCount: tag.eligible_count != null ? Number(tag.eligible_count) : null
  }))
}
